import { Injectable, HostListener, Inject } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { WINDOW } from "./windows.service";
// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
	rol?: string;
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false

	constructor(@Inject(WINDOW) private window) {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener("window:resize", ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	/* MENUITEMS: Menu[] = [
		{
			path: '/dashboard/default', title: 'Dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Products', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Physical', type: 'sub', children: [
						{ path: '/products/physical/category', title: 'Category', type: 'link' },
						{ path: '/products/physical/sub-category', title: 'Sub Category', type: 'link' },
						{ path: '/products/physical/product-list', title: 'Product List', type: 'link' },
						{ path: '/products/physical/product-detail', title: 'Product Detail', type: 'link' },
						{ path: '/products/physical/add-product', title: 'Add Product', type: 'link' },
					]
				},
				{
					title: 'digital', type: 'sub', children: [
						{ path: '/products/digital/digital-category', title: 'Category', type: 'link' },
						{ path: '/products/digital/digital-sub-category', title: 'Sub Category', type: 'link' },
						{ path: '/products/digital/digital-product-list', title: 'Product List', type: 'link' },
						{ path: '/products/digital/digital-add-product', title: 'Add Product', type: 'link' },
					]
				},
			]
		},
		{
			title: 'Sales', icon: 'dollar-sign', type: 'sub', active: false, children: [
				{ path: '/sales/orders', title: 'Orders', type: 'link' },
				{ path: '/sales/transactions', title: 'Transactions', type: 'link' },
			]
		},
		{
			title: 'Coupons', icon: 'tag', type: 'sub', active: false, children: [
				{ path: '/coupons/list-coupons', title: 'List Coupons', type: 'link' },
				{ path: '/coupons/create-coupons', title: 'Create Coupons', type: 'link' },
			]
		},
		{
			title: 'Pages', icon: 'clipboard', type: 'sub', active: false, children: [
				{ path: '/pages/list-page', title: 'List Page', type: 'link' },
				{ path: '/pages/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Media', path: '/media', icon: 'camera', type: 'link', active: false
		},
		{
			title: 'Menus', icon: 'align-left', type: 'sub', active: false, children: [
				{ path: '/menus/list-menu', title: 'Menu Lists', type: 'link' },
				{ path: '/menus/create-menu', title: 'Create Menu', type: 'link' },
			]
		},
		{
			title: 'Users', icon: 'user-plus', type: 'sub', active: false, children: [
				{ path: '/users/list-user', title: 'User List', type: 'link' },
				{ path: '/users/create-user', title: 'Create User', type: 'link' },
			]
		},
		{
			title: 'Vendors', icon: 'users', type: 'sub', active: false, children: [
				{ path: '/vendors/list-vendors', title: 'Vendor List', type: 'link' },
				{ path: '/vendors/create-vendors', title: 'Create Vendor', type: 'link' },
			]
		},
		{
			title: 'Localization', icon: 'chrome', type: 'sub', children: [
				{ path: '/localization/translations', title: 'Translations', type: 'link' },
				{ path: '/localization/currency-rates', title: 'Currency Rates', type: 'link' },
				{ path: '/localization/taxes', title: 'Taxes', type: 'link' },
			]
		},
		{
			title: 'Reports', path: '/reports', icon: 'bar-chart', type: 'link', active: false
		},
		{
			title: 'Settings', icon: 'settings', type: 'sub', children: [
				{ path: '/settings/profile', title: 'Profile', type: 'link' },
			]
		},
		{
			title: 'Invoice', path: '/invoice', icon: 'archive', type: 'link', active: false
		},
		{
			title: 'Login',path: '/auth/login', icon: 'log-in', type: 'link', active: false
		}
	] */

	MENUITEMS: Menu[] = [
		{
			path: '/dashboard', title: 'Dashboard', icon: 'home', type: 'link', active: false, rol: 'admin'
		},
		{
			path: '/inicio', title: 'Inicio', icon: 'home', type: 'link', active: false, rol: 'teacher, collaborator, student'
		},
		{
			title: 'Productos', rol: 'admin', icon: 'shield-off', type: 'sub', active: false, children: [
				{ path: '/products/courses', title: 'Cursos', type: 'link' },
				{ path: '/products/ebooks', title: 'Ebooks', type: 'link' },
				{ path: '/products/capacitations', title: 'Capacitaciones', type: 'link' },
				{ path: '/products/webinars', title: 'Webinars', type: 'link' },
				{ path: '/products/events', title: 'Eventos', type: 'link' },
				{ path: '/products/catalogs', title: 'Catálogos', type: 'link' }
			]
		},
		{
			title: 'CRM', rol: 'admin', icon: 'users', type: 'sub', active: false, children: [
				{ path: '/leads', title: 'Prospectos', type: 'link' },
				{ path: '/lead-status', title: 'Mis estados', type: 'link' },
				{ path: '/lead-funnels', title: 'Mis embudos', type: 'link' },
			]
		},
		{
			title: 'Ventas', rol: "admin", path: '/Ventas', icon: 'shopping-cart', type: 'link', active: false
		},
		{
			title: 'Usuarios', rol: 'admin', icon: 'users', type: 'sub', active: false, children: [
				// { path: '/users/business', title: 'Empresas', type: 'link' },
				{ path: '/users', title: 'Miembros', type: 'link' },
				{ path: '/users/teachers', title: 'Instructores', type: 'link' },
				{ path: '/users/admins', title: 'Administradores', type: 'link' },
			]
		},
		{
			title: 'Productos', rol: 'teacher', icon: 'list', type: 'sub', active: false, children: [
				{ path: '/products/courses', title: 'Mis cursos', type: 'link' },
				{ path: '/products/ebooks', title: 'Ebooks', type: 'link' },
			]
		},
		{
			// ✅ REPOSICIONADO: Videoteca como menú principal con submenús (antes estaba al final)
			title: 'Videoteca', rol: 'teacher, collaborator', icon: 'video', type: 'sub', active: false, children: [
				{ path: '/Videoteca', title: 'Mi Videoteca', type: 'link' },
				{ path: '/Colaboradores', title: 'Colaboradores', type: 'link' }
			]
		},
		{
			title: 'CRM', rol: 'teacher', icon: 'users', type: 'sub', active: false, children: [
				
				{ path: '/students', title: 'Estudiantes', type: 'link' },
			
				{ path: '/leads', title: 'Prospectos', type: 'link' }
			]
		},
		{
			title: 'Configuración', rol: 'teacher', icon: 'settings', type: 'sub', active: false, children: [
				{ path: '/lead-status', title: 'Estados de seguimiento', type: 'link' },
				{ path: '/lead-funnels', title: 'Embudos', type: 'link' }
			]
		},
		// Menú específico para estudiantes - solo Inicio y Videoteca (solo lectura)
		{
			path: '/Videoteca', rol: 'student', icon: 'video', title: 'Videoteca', type: 'link', active: false
		}
	]

	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
